// Modal state belongs to the current page. Preserve its filters and fragment.
export function getModalHref(asPath, modal = null) {
  const url = new URL(asPath, "https://catchy.invalid");
  url.searchParams.delete("modal");
  if (modal) url.searchParams.set("modal", modal);
  return `${url.pathname}${url.search}${url.hash}`;
}
